import { render, staticRenderFns, recyclableRender, components } from "./exam-result.vue?vue&type=template&id=688e6396&scoped=true&"
var renderjs
import script from "./exam-result.vue?vue&type=script&lang=js&"
export * from "./exam-result.vue?vue&type=script&lang=js&"
import style0 from "./exam-result.vue?vue&type=style&index=0&id=688e6396&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../Applications/HBuilderX.app/Contents/HBuilderX/plugins/uniapp-cli/node_modules/@dcloudio/vue-cli-plugin-uni/packages/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "688e6396",
  null,
  false,
  components,
  renderjs
)

component.options.__file = "pages/question-bank/exam-result.vue"
export default component.exports